// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__st7Zp","pdf":"Footer_pdf__1jt-j"};